module.exports = __webpack_public_path__ + "img/mobile-layout-header.f1bf9c51.svg";